module.exports = __webpack_public_path__ + "static/media/Turkey Costume.332b1307.jpg";